module.exports = __webpack_public_path__ + "static/media/defaultAvatar7.7f4e029b.svg";